// Product copy. Keep Simplified and Traditional wording together.
import {radarCustomerCopy} from './radarCustomerCopy';
export const radarProductCopy: Record<string, readonly [string, string]> = {
  'Quick start guide': ['新手指南','新手指南'],
  'Opens in a new tab': ['在新标签页打开','在新分頁開啟'],
  'Monitoring now': ['家监测中','家監測中'],
  'Unused': ['未用额度','未用額度'],
  'Remaining': ['剩余额度','剩餘額度'],
  'Back to usage': ['返回用量','返回用量'],
  'Monthly': ['月付','月付'],
  ' / month': [' / 月',' / 月'],
  'Keep finding your next buyers': ['持续找到下一批买家','持續找到下一批買家'],
  'One workspace subscription. Keep your existing companies and contact history.': ['按工作区订阅，沿用已有公司与联系记录。','按工作區訂閱，沿用已有公司與聯絡記錄。'],
  '{count} new companies': ['{count} 家新公司','{count} 家新公司'],
  '{count} companies with email': ['{count} 家公司邮箱','{count} 家公司信箱'],
  '{count} outreach drafts': ['{count} 份开发信草稿','{count} 份開發信草稿'],
  '{count} monitoring slots': ['{count} 个监测名额','{count} 個監測名額'],
  'Monitoring updates every {days} days.': ['监测每 {days} 天更新一次。','監測每 {days} 天更新一次。'],
  'Billing cycle': ['订阅周期','訂閱週期'],
  'Renews monthly': ['每月自动续费','每月自動續費'],
  'Cancellation': ['取消方式','取消方式'],
  'Cancel the next renewal': ['可取消下次续费','可取消下次續費'],
  'Beyond your allowance': ['超出额度','超出額度'],
  'New work pauses. No automatic extra charges.': ['停止新增，不自动加收','停止新增，不自動加收'],
  'Basic replaces unused trial allowance. Existing results are kept. Monthly unused allowances do not roll over.': ['升级后，Basic 额度替换剩余试用额度，已有结果保留。每月未用额度不结转。','升級後，Basic 額度取代剩餘試用額度，已有結果保留。每月未用額度不結轉。'],
  'Continue to Stripe': ['前往 Stripe 付款','前往 Stripe 付款'],
  'Paid upgrades are not open yet': ['付费升级即将开放','付費升級即將開放'],
  'Confirm the amount and pay on Stripe, then return to this workspace.': ['在 Stripe 确认金额并付款，然后回到当前工作区。','在 Stripe 確認金額並付款，然後回到目前工作區。'],
  'Upgrading is not available for this workspace right now. Your existing results remain available.': ['当前工作区暂未开放升级，已有结果仍可查看。','目前工作區暫未開放升級，已有結果仍可查看。'],
  'Monthly allowances for one workspace': ['每个工作区，按月补充额度','每個工作區，按月補充額度'],
  'Upgrade to Basic': ['升级至 Basic','升級至 Basic'],
  'View Basic plan': ['查看 Basic 套餐','查看 Basic 方案'],
  'Feedback makes the next batch better': ['反馈，让下一批更准','回饋，讓下一批更準'],
  'Trial rewards claimed': ['试用奖励已全部领取','試用獎勵已全部領取'],
  'Up to {count} companies': ['最多 {count} 家公司','最多 {count} 家公司'],
  'Trial reward progress': ['试用奖励进度','試用獎勵進度'],
  'Trial start': ['开始试用','開始試用'],
  'Feedback adds {count} companies, company emails and drafts.': ['反馈后，公司、邮箱和草稿额度各 +{count}。','回饋後，公司、信箱和草稿額度各 +{count}。'],
  'Help shape the next batch': ['下一批，怎样更有帮助？','下一批，怎樣更有幫助？'],
  'Basic is active. Your confirmed allowances are shown above.': ['Basic 已生效，当前额度已显示在上方。','Basic 已生效，目前額度已顯示在上方。'],
  'No new payment has been confirmed. If you just paid, refresh shortly. Returning from Stripe does not change your allowance.': ['暂未确认新的付款。如已付款，请稍后刷新；返回工作区不会直接增加额度。','暫未確認新的付款。如已付款，請稍後重新整理；返回工作區不會直接增加額度。'],
  'Refresh payment status': ['刷新付款状态','重新整理付款狀態'],
  'Renewal canceled': ['已取消下次续费','已取消下次續費'],
  'Monthly subscription': ['月付订阅','月付訂閱'],
  'Your existing results remain available. Manage your subscription to check payment status.': ['已有结果仍可查看，可在管理订阅中检查付款状态。','已有結果仍可查看，可在管理訂閱中檢查付款狀態。'],
  'Payment method, invoices and cancellation are managed on Stripe.': ['付款方式、发票和取消订阅均在 Stripe 管理。','付款方式、發票和取消訂閱均在 Stripe 管理。'],
  'Plan details could not be refreshed. Your confirmed balances are unchanged.': ['套餐暂时无法刷新，已确认的额度保持不变。','方案暫時無法重新整理，已確認的額度保持不變。'],
  "Earlier saved drafts and contacts": ["早期保存的草稿和联系人", "早期儲存的草稿和聯絡人"],
  "Could not refresh contacts. Your current list and edits are kept. Try again.": ["联系列表暂时无法刷新，当前列表和编辑内容已保留，请重试。", "聯絡清單暫時無法重新整理，目前清單和編輯內容已保留，請重試。"],
  "{count} companies included": ["纳入 {count} 家公司", "納入 {count} 家公司"],
  "Newest preparation first": ["按准备时间，最新在前", "按準備時間，最新在前"],
  "Batch counts include companies without an email or draft.": ["批次数量指纳入准备的公司，包含未找到邮箱或未生成草稿的公司。", "批次數量指納入準備的公司，包含未找到信箱或未產生草稿的公司。"],
  "Search and filters cover loaded contacts. Load older contacts to include earlier batches.": ["搜索和筛选当前已载入的记录；载入更早记录可查看历史批次。", "搜尋和篩選目前已載入的記錄；載入更早記錄可查看歷史批次。"],
  "Showing {from}–{to} of {count} matching contacts": ["显示第 {from}–{to} 条，共 {count} 条匹配记录", "顯示第 {from}–{to} 筆，共 {count} 筆符合條件的記錄"],
  "All available contacts loaded": ["历史联系记录已全部载入", "歷史聯絡記錄已全部載入"],
  "Rows per page": ["每页显示", "每頁顯示"],
  "Contact pages": ["联系记录分页", "聯絡記錄分頁"],
  "Page {page} of {pages}": ["第 {page} / {pages} 页", "第 {page} / {pages} 頁"],

  'Basic': ['Basic','Basic'],
  'Plan inactive': ['套餐已到期','方案已到期'],
  'Counting rules': ['计量规则','計量規則'],
  'Allowances renew after each monthly payment. Unused allowances do not roll over.': ['每月付款成功后更新额度，未用额度不结转。','每月付款成功後更新額度，未用額度不結轉。'],
  'Allowances renew after a successful monthly payment.': ['每月付款成功后更新额度。','每月付款成功後更新額度。'],
  'Cancels at the end of this period.': ['本账期结束后取消续订。','本帳期結束後取消續訂。'],
  'Payment needs attention. Manage your subscription to update payment details.': ['付款需要处理，请在管理订阅中更新付款方式。','付款需要處理，請在管理訂閱中更新付款方式。'],
  'Plan & feedback': ['套餐与反馈','方案與回饋'],
  'More trial allowance with your feedback': ['反馈后，继续体验','回饋後，繼續體驗'],
  'Each reward adds companies, company emails and drafts. Your original expiry stays the same.': ['每轮奖励同时增加公司、公司邮箱和草稿额度，试用到期日不变。','每輪獎勵同時增加公司、公司信箱和草稿額度，試用到期日不變。'],
  'First feedback': ['第一轮反馈','第一輪回饋'],
  'Detailed feedback': ['详细反馈','詳細回饋'],
  'Already included': ['已计入上方额度','已計入上方額度'],
  'After your first feedback': ['完成第一轮反馈后开放','完成第一輪回饋後開放'],
  'Ready when you are': ['随时可以提交','隨時可以提交'],
  'Share first feedback': ['提交第一轮反馈','提交第一輪回饋'],
  'Share detailed feedback': ['填写详细反馈','填寫詳細回饋'],
  'Honest feedback helps, including results that missed the mark.': ['请如实反馈，不匹配的结果也很有帮助。','請如實回饋，不匹配的結果也很有幫助。'],
  'How did the first companies match?': ['第一批公司与需求匹配吗？','第一批公司與需求匹配嗎？'],
  'Company name or website': ['公司名称或网站','公司名稱或網站'],
  'How relevant was it?': ['与需求的匹配程度','與需求的匹配程度'],
  'Not enough information': ['信息不足','資訊不足'],
  'What worked or missed the mark?': ['具体哪里合适，或哪里不合适？','具體哪裡合適，或哪裡不合適？'],
  'What information would help?': ['还希望看到哪些信息？','還希望看到哪些資訊？'],
  'What should the next search change?': ['下一轮希望调整什么？','下一輪希望調整什麼？'],
  'Submit feedback · +{count}': ['提交反馈 · +{count}','提交回饋 · +{count}'],
  ' / workspace / month': [' / 工作区 / 月',' / 工作區 / 月'],
  '{companies} companies · {emails} company emails · {drafts} drafts per month': ['每月 {companies} 家公司 · {emails} 家公司邮箱 · {drafts} 份草稿','每月 {companies} 家公司 · {emails} 家公司信箱 · {drafts} 份草稿'],
  '{count} monitoring slots · every {days} days': ['{count} 个监测名额 · 每 {days} 天更新','{count} 個監測名額 · 每 {days} 天更新'],
  'Continue with Basic': ['开通 Basic','開通 Basic'],
  'Monthly payment. Cancel before renewal. No automatic overage charges.': ['按月付费，可在续费前取消，不自动收取超额费用。','按月付費，可在續費前取消，不自動收取超額費用。'],
  'Manage subscription': ['管理订阅','管理訂閱'],
  'Loading plan…': ['正在读取套餐…','正在讀取方案…'],
  'Plan details could not be loaded. Your allowances are unchanged.': ['套餐信息暂时无法读取，额度未受影响。','方案資訊暫時無法讀取，額度未受影響。'],
  'This did not complete. Please try again; confirmed balances are shown above.': ['操作尚未完成，请重试。已确认的额度显示在上方。','操作尚未完成，請重試。已確認的額度顯示在上方。'],

  ...radarCustomerCopy,
  "Market brief": ["市场简报", "市場簡報"],
  "View results": ["查看结果", "查看結果"],
  "Market brief versions": ["市场简报版本", "市場簡報版本"],
  "Versions": ["版本记录", "版本記錄"],
  "Earlier saved brief": ["历史简报", "歷史簡報"],
  "Currently in use": ["当前使用", "目前使用"],
  "Edit from this version": ["基于此版编辑", "基於此版編輯"],
  "Search with v{version}": ["用 v{version} 继续搜索", "用 v{version} 繼續搜尋"],
  "Target customers": ["目标客户", "目標客戶"],
  "Relationship goal": ["合作目标", "合作目標"],
  "Exclusions": ["排除条件", "排除條件"],
  "Results for brief": ["搜索所用简报", "搜尋所用簡報"],
  "All versions": ["全部版本", "全部版本"],
  "First found · v{version}": ["首次发现 · v{version}", "首次發現 · v{version}"],
  "Historical source": ["历史来源", "歷史來源"],
  "Brief used when this company was first discovered": ["首次发现这家公司时使用的简报", "首次發現這家公司時使用的簡報"],
  "Email settings": ["邮件设置", "郵件設定"],
  "Email preview": ["邮件预览", "郵件預覽"],
  "Reference email": ["参考邮件", "參考郵件"],
  "Paste a complete email, including your offer, next step and signature.": ["粘贴一封完整邮件，包含你提供什么、希望对方做什么，以及签名。", "貼上一封完整郵件，包含你提供什麼、希望對方做什麼，以及簽名。"],
  "We follow its language, tone and signature, and adapt the facts for each company.": ["沿用这封邮件的语言、语气和签名，根据每家公司的资料调整内容。", "沿用這封郵件的語言、語氣和簽名，根據每家公司的資料調整內容。"],
  "Used for new email batches you prepare here.": ["用于之后在这里准备的新草稿。", "用於之後在這裡準備的新草稿。"],
  "Save email settings": ["保存邮件设置", "儲存郵件設定"],
  "Preview uses existing company evidence. Optional buying-signal research runs when preparing the batch.": ["预览使用已有公司资料。选择补充研究后，会在准备这批邮件时查找采购线索。", "預覽使用已有公司資料。選擇補充研究後，會在準備這批郵件時查找採購線索。"],
  "Review and send in Gmail.": ["在 Gmail 审阅并发送。", "在 Gmail 審閱並傳送。"],
  "Loading email settings…": ["正在加载邮件设置…", "正在載入郵件設定…"],
  "Research buying signals for this outreach": ["为本次联系补充采购线索", "為本次聯絡補充採購線索"],
  "For example: supplier invitations or published purchasing requirements.": ["例如：寻找新供应商、供应商招募或公开采购需求。", "例如：尋找新供應商、供應商招募或公開採購需求。"],
  "What should we look for?": ["这次重点找什么？", "這次重點找什麼？"],
  "New supplier search, supplier invitations, purchasing requirements": ["寻找新供应商、供应商招募、采购需求", "尋找新供應商、供應商招募、採購需求"],
  "Only verified signals are used. If none are found, we use the company fit instead.": ["只使用有依据的线索；没找到时，仍根据公司匹配情况准备邮件。", "只使用有依據的線索；沒找到時，仍根據公司匹配情況準備郵件。"],
  "Preview one email": ["预览一封", "預覽一封"],
  "Generate and save {count} drafts": ["生成并保存 {count} 封草稿", "產生並儲存 {count} 封草稿"],
  "This saves drafts only. No emails will be sent.": ["只保存草稿，不会发送邮件。", "只儲存草稿，不會傳送郵件。"],
  "Current": ["当前", "目前"],
  "Back": ["返回", "返回"],
  "Edit": ["编辑", "編輯"],
  "Connect Gmail": ["连接 Gmail", "連接 Gmail"],
  'Research is paused for today. Your result allowance is unchanged. Please try again tomorrow.': ['今日研究暂时暂停，结果额度未扣减，请明天再试。', '今日研究暫時暫停，結果額度未扣減，請明天再試。'],
  "Companies with email": ["已找到邮箱的公司", "已找到信箱的公司"],
  "One credit per company with a sourced business email or a verified contact email. Verification status is shown with each contact. Failed lookups and repeat views are free.": ["按公司计量：找到有来源的企业邮箱或经过验证的联系人邮箱时计一份，具体验证状态随联系方式展示。未找到和重复查看不扣。", "按公司計量：找到有來源的企業信箱或經過驗證的聯絡人信箱時計一份，具體驗證狀態隨聯絡方式展示。未找到和重複查看不扣。"],
  "Could not refresh usage. These are the last confirmed balances.": ["用量暂时无法更新，当前显示上次确认的余额。", "用量暫時無法更新，目前顯示上次確認的餘額。"],
  "Review 10 different companies to receive 100 more companies, 20 company emails and 20 drafts. Positive and negative feedback both count.": ["评价 10 家不同公司，即可加赠 100 家公司、20 份公司邮箱和 20 份草稿。相关或不匹配的反馈都计入。", "評價 10 家不同公司，即可加贈 100 家公司、20 份公司信箱和 20 份草稿。相關或不匹配的回饋都計入。"],
  "Review companies": ["评价公司", "評價公司"],
  "This allowance is used up. Open Usage & plan to check your balance.": ["此项额度已用完，请在「用量与套餐」中查看余额。", "此項額度已用完，請在「用量與方案」中查看餘額。"],
  "Your trial has ended. Your existing results are still available.": ["试用已结束，已有结果仍可查看。", "試用已結束，已有結果仍可查看。"],
  "This company is already being processed. Wait for its result before retrying.": ["这家公司正在处理中，请等待结果后重试。", "這家公司正在處理中，請等待結果後重試。"],
  "Email allowance is counted once per company. Existing company emails remain available.": ["邮箱额度按公司扣一次，已获得的公司邮箱可继续查看。", "信箱額度按公司扣一次，已取得的公司信箱可繼續查看。"],
  "Revealing this email uses at most one company email allowance. Further emails for the same company are included.": ["查看此邮箱最多扣 1 份公司邮箱额度，同一公司的后续邮箱不重复扣。", "查看此信箱最多扣 1 份公司信箱額度，同一公司的後續信箱不重複扣。"],
  "Reveal email · included": ["查看邮箱 · 已包含", "查看信箱 · 已包含"],
  "Reveal email · 1 company": ["查看邮箱 · 1 家公司", "查看信箱 · 1 家公司"],
  "A successfully saved new draft uses one draft allowance. Manual edits and exports are free.": ["新草稿成功保存后扣 1 份草稿额度，手动修改和导出免费。", "新草稿成功儲存後扣 1 份草稿額度，手動修改和匯出免費。"],
  "Usage & plan": ["用量与套餐","用量與方案"],
  "Workspace usage": ["工作区用量","工作區用量"],
  "Free trial": ["免费试用","免費試用"],
  "Trial ended": ["试用已结束","試用已結束"],
  "Close usage": ["关闭用量面板","關閉用量面板"],
  "View usage": ["查看用量","查看用量"],
  "Company discovery": ["公司发现","公司探索"],
  "Outreach drafts": ["开发信草稿","開發信草稿"],
  "{used} / {limit} used": ["已用 {used} / {limit}","已用 {used} / {limit}"],
  "{used} / {limit} active": ["监测中 {used} / {limit}","監測中 {used} / {limit}"],
  "{count} companies available": ["可发现 {count} 家公司","可探索 {count} 家公司"],
  "{count} companies unused": ["未用 {count} 家公司额度","未用 {count} 家公司額度"],
  "{count} companies with email available": ["可为 {count} 家公司查找邮箱","可為 {count} 家公司尋找信箱"],
  "{count} companies with email unused": ["未用 {count} 家邮箱额度","未用 {count} 家信箱額度"],
  "{count} drafts available": ["可生成 {count} 份草稿","可產生 {count} 份草稿"],
  "{count} drafts unused": ["未用 {count} 份草稿额度","未用 {count} 份草稿額度"],
  "{count} monitoring slots available": ["还可监测 {count} 家公司","還可監測 {count} 家公司"],
  "{count} monitoring slots unused": ["未用 {count} 个监测名额","未用 {count} 個監測名額"],
  "{used} / {limit} monitoring slots active": ["监测中 {used} / {limit} 家","監測中 {used} / {limit} 家"],
  "{count} reserved for work in progress": ["进行中的任务预留 {count} 个额度","進行中的任務預留 {count} 個額度"],
  "Running low": ["额度较少","額度較少"],
  "Work in progress": ["处理中","處理中"],
  "Allowance used": ["额度已用完","額度已用完"],
  "Company allowance used": ["公司额度已用完","公司額度已用完"],
  "Access ends {date}": ["试用到期：{date}","試用到期：{date}"],
  "Usage is unavailable. Refresh the workspace to try again.": ["暂时无法读取用量，请刷新工作区重试。","暫時無法讀取用量，請重新整理工作區重試。"],
  "Discovery searches": ["发现买家搜索","探索買家搜尋"],
  "Your current pilot allowance is measured in searches. One search can return multiple companies.": ["当前试用额度按搜索次数计量，一次搜索可返回多家公司。","目前試用額度按搜尋次數計量，一次搜尋可傳回多家公司。"],
  "Trial & counting rules": ["试用说明与计量规则","試用說明與計量規則"],
  "Allowance information": ["额度说明","額度說明"],
  "Allowances cover the entire trial period; they do not reset daily.": ["额度为整个试用期总额，不会每天重置。","額度為整個試用期總額，不會每天重設。"],
  "Only new, matching companies delivered to your workspace count. Repeats and empty results do not.": ["仅按交付到工作区的匹配新公司计量；重复公司和无结果不扣。","僅按交付到工作區的匹配新公司計量；重複公司與無結果不扣。"],
  "Active monitoring slots. Pausing a company releases its slot.": ["按正在监测的公司占用名额，暂停后释放。","按正在監測的公司占用名額，暫停後釋出。"],
  "Counted when a new draft is saved. Viewing, manual editing and export do not count.": ["新草稿保存成功后计量，查看、手动编辑和导出不扣。","新草稿儲存成功後計量，查看、手動編輯與匯出不扣。"],
  "Reservations are held while work runs. Only delivered results are charged; unused reservations are released.": ["任务进行时会预留额度；完成后按实际交付扣减，未用预留会释放。","任務進行時會預留額度；完成後按實際交付扣減，未用預留會釋出。"],
  "These are the allowances currently granted to your account. Changes to result-based plans will be shown here when available.": ["这里显示账户当前已获配的额度。按结果计量的套餐启用后会在这里更新。","這裡顯示帳戶目前已獲配的額度。按結果計量的方案啟用後會在這裡更新。"],
  "Feedback bonus included in these balances.": ["反馈赠送额度已计入上方余额。","回饋贈送額度已計入上方餘額。"],
  "{completed} / {required} company reviews completed.": ["已评价 {completed} / {required} 家公司。","已評價 {completed} / {required} 家公司。"],
  "Your Expo results, saved.": ["展会上的结果，已为你保存。", "展會上的結果，已為你保存。"],
  "Use the email you shared at the Expo. Verify it to open your results and continue in Buyer Radar.": ["使用在展会上留下的邮箱，验证后即可查看结果并继续使用 Buyer Radar。", "使用在展會上留下的電郵，驗證後即可查看結果並繼續使用 Buyer Radar。"],
  "Your existing workspaces stay with you. Expo trial searches are added once per account.": ["原有工作区会保留，展会体验额度每个账号赠送一次。", "原有工作區會保留，展會體驗額度每個帳號贈送一次。"],
  "Companies to contact": ["值得联系的公司", "值得聯繫的公司"],
  "Clear signals first. Every matching company is a potential conversation.": ["明确信号优先呈现，每家匹配公司都值得开启对话。", "明確訊號優先呈現，每家匹配公司都值得開啟對話。"],
  "Draft recorded": ["已有草稿记录", "已有草稿紀錄"],
  "Monitor": ["监测", "監測"],
  "Resume monitoring": ["恢复监测", "恢復監測"],
  "Monitor {name}": ["监测 {name}", "監測 {name}"],
  "Company scope": ["公司范围", "公司範圍"],
  "All companies": ["全部公司", "全部公司"],
  "Ready to prepare": ["待准备", "待準備"],
  "With progress": ["已有进度", "已有進度"],
  "Not fit": ["不合适", "不合適"],
  "Search company list": ["搜索公司", "搜尋公司"],
  "Clear signals only": ["仅看明确信号", "只看明確訊號"],
  "Sort companies": ["公司排序", "公司排序"],
  "Signals first": ["信号优先", "訊號優先"],
  "Recently discovered": ["最近发现", "最近發現"],
  "Company name": ["公司名称", "公司名稱"],
  "Company workspace": ["公司工作区", "公司工作區"],
  "Select this page": ["选择本页", "選擇本頁"],
  "Company": ["公司", "公司"],
  "Why it fits": ["为什么匹配", "為什麼匹配"],
  "Contact timing": ["联系时机", "聯繫時機"],
  "Contact progress": ["联系进度", "聯繫進度"],
  "Prepare {name}": ["准备联系 {name}", "準備聯繫 {name}"],
  "Fits your brief": ["符合目标画像", "符合目標畫像"],
  "No companies match this view.": ["当前筛选下没有公司。", "目前篩選下沒有公司。"],
  "{count} companies in this view": ["当前范围 {count} 家公司", "目前範圍 {count} 家公司"],
  "Previous page": ["上一页", "上一頁"],
  "Next page": ["下一页", "下一頁"],
  "Company details": ["公司详情", "公司詳情"],
  "Close details": ["关闭详情", "關閉詳情"],
  "{count} companies selected": ["已选 {count} 家公司", "已選 {count} 家公司"],
  "{count} selected outside this view": ["另有 {count} 家已选公司不在本页", "另有 {count} 家已選公司不在本頁"],
  "Up to 40 companies per batch": ["每批最多 40 家公司", "每批最多 40 家公司"],
  "Clear selection": ["清空选择", "清空選擇"],
  "Generate and save to Gmail": ["生成并存入 Gmail", "產生並存入 Gmail"],
  "Confirm and save {count} drafts": ["确认并保存 {count} 封草稿", "確認並儲存 {count} 封草稿"],
  "Find companies. Start a conversation.": ["找到公司，开始联系。", "找到公司，開始聯繫。"],
  "Select companies to generate Gmail drafts. Clear signals help you prioritize; matching companies can be contacted too.": ["选择公司，生成 Gmail 草稿。明确信号帮助你优先判断；其他匹配公司也可以联系。", "選擇公司，產生 Gmail 草稿。明確訊號協助你優先判斷；其他匹配公司也可以聯繫。"],
  "View all contacts": ["查看全部联系", "查看全部聯繫"],
  "Preparing and saving in the background": ["正在后台准备并保存", "正在背景準備並儲存"],
  "Gmail saving needs attention": ["Gmail 保存需处理", "Gmail 儲存需處理"],
  "saved": ["已保存", "已儲存"],
  "Not started": ["尚未开始", "尚未開始"],
  "Needs attention": ["需处理", "需處理"],
  "All contacts": ["全部联系", "全部聯繫"],
  "Every company, one conversation history. Review and send from Gmail.": ["集中查看每家公司的联系进度，在 Gmail 审阅并发送。", "集中查看每家公司的聯繫進度，在 Gmail 審閱並寄出。"],
  "Search contacts": ["搜索联系记录", "搜尋聯繫紀錄"],
  "Preparation batch": ["准备批次", "準備批次"],
  "Refresh drafts": ["刷新邮件状态", "重新整理郵件狀態"],
  "Refreshing…": ["刷新中…", "重新整理中…"],
  "Email unavailable": ["暂无邮箱", "暫無信箱"],
  "Saved to Gmail is a draft. Sending and replies update after Gmail checks.": ["「已存 Gmail」表示草稿已保存；发送和回复状态会在核对 Gmail 后更新。", "「已存 Gmail」表示草稿已儲存；寄送和回覆狀態會在核對 Gmail 後更新。"],
  "Search companies or email": ["搜索公司或邮箱", "搜尋公司或信箱"],
  "All progress": ["全部进度", "全部進度"],
  "Preparing": ["准备中", "準備中"],
  "Engagement": ["对方互动", "對方互動"],
  "All engagement": ["全部互动", "全部互動"],
  "No reply yet": ["暂无回复", "暫無回覆"],
  "Not sent": ["尚未发送", "尚未寄出"],
  "Send status unconfirmed": ["发送状态待核对", "寄送狀態待核對"],
  "All batches": ["全部批次", "全部批次"],
  "companies": ["家公司", "家公司"],
  "Contact email": ["联系邮箱", "聯繫信箱"],
  "Action": ["操作", "操作"],
  "Email source": ["邮箱来源", "信箱來源"],
  "Review draft": ["查看草稿", "查看草稿"],
  "Earlier export": ["来自较早的草稿", "來自較早的草稿"],
  "Reconnect Gmail to refresh status": ["重新连接 Gmail 以更新状态", "重新連接 Gmail 以更新狀態"],
  "Sending check failed": ["发送核对未完成", "寄送核對未完成"],
  "Open Gmail": ["打开 Gmail", "開啟 Gmail"],
  "No sourced email found": ["未找到有来源的邮箱", "未找到有來源的信箱"],
  "Research incomplete": ["研究未完成", "研究未完成"],
  "Not available yet": ["暂未找到", "暫未找到"],
  "Draft abandoned": ["草稿已放弃", "草稿已放棄"],
  "Imported contact": ["导入的联系记录", "匯入的聯繫紀錄"],
  "Nothing in this view": ["当前筛选下没有记录", "目前篩選下沒有紀錄"],
  "Choose your first companies": ["先选择要联系的公司", "先選擇要聯繫的公司"],
  "Adjust the filters to see other contacts.": ["调整筛选可查看其他联系记录。", "調整篩選可查看其他聯繫紀錄。"],
  "Select companies in Discover and confirm Gmail draft preparation.": ["在 Discover 选择公司，并确认生成 Gmail 草稿。", "在 Discover 選擇公司，並確認產生 Gmail 草稿。"],
  "Load older contacts": ["加载更早的联系记录", "載入更早的聯繫紀錄"],
  "All loaded contacts": ["已显示全部记录", "已顯示全部紀錄"],
  "Open signals may come from image proxies. Replies show status and time; read the conversation in Gmail.": ["打开信号可能来自图片代理。回复记录显示状态与时间；请在 Gmail 阅读往来内容。", "開啟訊號可能來自圖片代理。回覆紀錄顯示狀態與時間；請在 Gmail 閱讀往來內容。"],
  "Save drafts to": ["将草稿保存至", "將草稿儲存至"],
  "Review, edit and send from Gmail. Preparation continues when you leave this page.": ["在 Gmail 审阅、编辑并发送。离开此页后，后台仍会继续准备。", "在 Gmail 審閱、編輯並寄出。離開此頁後，背景仍會繼續準備。"],
  "Background Gmail saving is not available yet.": ["后台保存 Gmail 尚未开放。", "背景儲存 Gmail 尚未開放。"],
  "Connect Gmail to check contact history and save drafts. Google includes sending in this permission; Buyer Radar only saves drafts.": ["连接 Gmail 以核对联系历史并保存草稿。Google 将发送功能包含在此权限中；Buyer Radar 仅保存草稿。", "連接 Gmail 以核對聯繫歷史並儲存草稿。Google 將寄送功能包含在此權限中；Buyer Radar 僅儲存草稿。"],
  "Change Gmail account": ["更换 Gmail 账号", "更換 Gmail 帳號"],
  "Connect Gmail for drafts": ["连接 Gmail 保存草稿", "連接 Gmail 儲存草稿"],
  "Close preparation": ["关闭准备窗口", "關閉準備視窗"],
  "Reconnect the original Gmail account": ["请重新连接本批次确认的 Gmail 账号", "請重新連接本批次確認的 Gmail 帳號"],
  "Contact history could not be checked completely": ["联系历史核对未完成", "聯繫歷史核對未完成"],
  "Successful drafts are kept. Retry saving the remaining drafts.": ["已成功保存的草稿会保留，可重试保存其余草稿。", "已成功儲存的草稿會保留，可重試儲存其餘草稿。"],
  "Retry Gmail saving": ["重试保存 Gmail", "重試儲存 Gmail"],
  "Contact history could not be checked completely. Existing sent and reply records are kept.": ["联系历史核对未完成。已有的发送与回复记录仍保留。", "聯繫歷史核對未完成。已有的寄送與回覆紀錄仍保留。"],
  "Monitor · your selected companies": ["Monitor · 已关注公司", "Monitor · 已關注公司"],
  "Stay close to what changes.": ["关注值得行动的变化。", "關注值得行動的變化。"],
  "Monitor company signals. Prepare first emails from Discover; follow conversations in Act.": ["在这里监测公司信号；在 Discover 准备首封邮件，在 Act 查看联系进展。", "在這裡監測公司訊號；在 Discover 準備首封郵件，在 Act 查看聯繫進展。"],
  "Monitor views": ["监测视图", "監測檢視"],
  "All watched": ["全部关注", "全部關注"],
  "Search monitored companies": ["搜索关注的公司", "搜尋關注的公司"],
  "Monitoring status": ["监测状态", "監測狀態"],
  "All statuses": ["全部状态", "全部狀態"],
  "Monitoring": ["监测中", "監測中"],
  "Brief changed": ["简报已变更", "簡報已變更"],
  "Monitored companies": ["关注的公司", "關注的公司"],
  "Latest signal": ["最近信号", "最近訊號"],
  "Monitoring details": ["监测详情", "監測詳情"],
  "Previous contact research": ["已有联系人资料", "已有聯絡人資料"],
  "No previous contact research": ["尚无联系人资料", "尚無聯絡人資料"],
  "View contact history in Act": ["在 Act 查看联系记录", "在 Act 查看聯繫紀錄"],
  "Choose Monitor on a company in Discover to check for new signals.": ["在 Discover 关注公司，即可开始检测新信号。", "在 Discover 關注公司，即可開始偵測新訊號。"],
  "Your Market Brief changed. Confirm that this company still fits before monitoring resumes.": ["市场简报已变更。确认这家公司仍符合目标后，再恢复监测。", "市場簡報已變更。確認這家公司仍符合目標後，再恢復監測。"],
  "Draft ready": ["草稿可审阅", "草稿可審閱"],
  "Saved to Gmail": ["已存 Gmail", "已存 Gmail"],
  "Sent": ["已发送", "已寄出"],
  "Replied": ["已回复", "已回覆"],
  "Export unavailable": ["暂不可保存", "暫不可儲存"],
  "Excluded from this batch": ["本批次已跳过", "本批次已略過"],
  "Queued for preparation": ["等待准备", "等待準備"],
  "Finding contacts and preparing draft": ["正在找联系人并准备草稿", "正在找聯絡人並準備草稿"],
  "Waiting for research budget": ["等待研究额度", "等待研究額度"],
  "Stopped at the research budget": ["已达研究预算", "已達研究預算"],
  "No supported buyer match": ["暂未匹配到有依据的买家机会", "暫未配對到有依據的買家機會"],
  "Do not contact": ["请勿联系", "請勿聯繫"],
  "Bounced": ["已退信", "已退信"],
  "Already preparing or drafted": ["已在准备或已有草稿", "已在準備或已有草稿"],
  "Draft already in Gmail": ["草稿已存 Gmail", "草稿已存 Gmail"],
  "Already contacted": ["已有联系记录", "已有聯繫紀錄"],
  "Marked Not Fit": ["已标记不合适", "已標記不合適"],
  "Your offer": ["你能提供什么", "你能提供什麼"],
  "Next step to offer": ["希望推进的下一步", "希望推進的下一步"],
  "Saved buyer hook": ["已保存的买家机会", "已儲存的買家機會"],
  "Materials, sender and research budget": ["资料、发件人及研究预算", "資料、寄件人及研究預算"],
  "Buyer opportunity materials (optional)": ["买家机会资料（选填）", "買家機會資料（選填）"],
  "Batch research ceiling (US$)": ["本批研究上限（美元）", "本批研究上限（美元）"],
  "Public sources first. Paid contact unlocking is off for this preview.": ["优先使用公开来源；当前预览不付费解锁联系人。", "優先使用公開來源；目前預覽不付費解鎖聯絡人。"],
  "Find contact details, then prepare drafts for companies with a sourced email. No email is sent.": ["查找联系渠道，再为找到有来源邮箱的公司生成草稿。此操作不会发送邮件。", "查找聯繫管道，再為找到有來源信箱的公司產生草稿。此操作不會寄出郵件。"],
  "Add contacts": ["添加联系", "新增聯繫"],
  "Review": ["查看", "查看"],
  "Close": ["关闭", "關閉"],
  "Sending verification code…": ["正在发送验证码…", "正在傳送驗證碼…"],
  "Diagnostic ID: {id}": ["诊断编号：{id}", "診斷編號：{id}"],
  "This request is taking longer than expected. Its result is not yet known.": ["请求耗时较长，目前还不能确认结果。", "請求耗時較長，目前還不能確認結果。"],
  "Verifying code…": ["正在验证…", "正在驗證…"],
  "Opening your workspace…": ["正在打开工作台…", "正在開啟工作台…"],
  "Opening Google sign-in…": ["正在打开 Google 登录…", "正在開啟 Google 登入…"],
  "First choose your sending Gmail account. Then save the selected drafts; nothing is sent.": ["先选择用于发信的 Gmail 账号，再保存选中的草稿；此操作不会发送邮件。", "先選擇用於寄信的 Gmail 帳號，再儲存選取的草稿；此操作不會寄出郵件。"],

  "Select a ready draft above to choose a Gmail account.": ["请先在上方选择一封可导出的草稿，再选择 Gmail 账号。", "請先在上方選擇一封可匯出的草稿，再選擇 Gmail 帳號。"],
  "We could not build a complete brief from your material. Your input is unchanged; please try again.": ["暂时无法根据资料生成完整简报。你的输入已保留，请重试。", "暫時無法根據資料生成完整簡報。你的輸入已保留，請重試。"],
  "Email open signals": ["邮件打开信号", "郵件開啟訊號"],
  "New exports include a tracking image when open signals are enabled. Use the connected sending address; send-as aliases cannot be checked yet.": ["开启打开信号后，新导出的邮件会带追踪图片。请使用连接的邮箱地址发信；暂不支持核对以别名发送的邮件。", "啟用郵件開啟訊號後，新匯出的郵件會帶追蹤圖片。請使用連接的信箱地址寄信；暫不支援核對以別名寄出的郵件。"],
  "Open signal observed": ["观察到打开信号", "觀察到開啟訊號"],
  "No open signal yet": ["暂无打开信号", "暫無開啟訊號"],
  "Awaiting check": ["待核对", "待核對"],
  "Tracking unavailable": ["无法追踪", "無法追蹤"],
  "Checking…": ["正在核对…", "正在核對…"],
  "Refresh": ["刷新", "重新整理"],
  "Last checked": ["上次核对", "上次核對"],
  "New Gmail exports include an image to record open signals. Your own Gmail views and automatic image loading may also trigger a signal; no signal does not mean unread.": ["新导出的 Gmail 草稿会包含用于记录打开信号的图片。你自己查看 Gmail 或邮件自动加载图片也可能触发信号；没有信号不代表未读。", "新匯出的 Gmail 草稿會包含用於記錄開啟訊號的圖片。你自己查看 Gmail 或郵件自動載入圖片也可能觸發訊號；沒有訊號不代表未讀。"],
  "Gmail connection is not configured yet.": ["Gmail 连接尚未配置。", "Gmail 連線尚未設定。"],
  "Reconnect Gmail to refresh email signals.": ["请重新连接 Gmail 以更新邮件信号。", "請重新連接 Gmail 以更新郵件訊號。"],
  "Could not check sending. Try refreshing again.": ["暂时无法核对发送情况，请重试刷新。", "暫時無法核對傳送情況，請重試更新。"],
  "Email signals could not refresh.": ["邮件信号暂时无法更新。", "郵件訊號暫時無法更新。"],
  "Gmail read permission is required to check sending. Draft export is unchanged.": ["核对发送情况需要 Gmail 读取权限，草稿导出不受影响。", "核對傳送情況需要 Gmail 讀取權限，草稿匯出不受影響。"],
  "Share a product page, describe what you sell, or provide both. We will draft a Market Brief for you to review.": ["提供产品页面，或直接介绍你销售什么，也可以两者都填。我们会生成市场简报，由你审核确认。", "提供產品頁面，或直接介紹你銷售甚麼，也可以兩者都填。我們會生成市場簡報，由你審核確認。"],
  "Product description": ["产品介绍", "產品介紹"],
  "Describe your main products, uses and any customization you offer. No website needed.": ["介绍主营产品、用途和定制能力等，没有网站也可以。", "介紹主營產品、用途和訂製能力等，沒有網站也可以。"],
  "At least one is required: a product link or a product description.": ["产品链接和产品介绍至少填写一项。", "產品連結和產品介紹至少填寫一項。"],
  "Provide a product link or describe what you sell.": ["请填写产品链接，或介绍你销售什么。", "請填寫產品連結，或介紹你銷售甚麼。"],
  "Reading your material and drafting…": ["正在阅读资料并生成初稿…", "正在閱讀資料並生成初稿…"],
  "The website could not be read. This draft uses your product description.": ["网站未能读取，本次初稿使用你填写的产品介绍。", "網站未能讀取，本次初稿使用你填寫的產品介紹。"],
  "We could not read product information. Try another link or enter your product description.": ["未能读取有效产品资料。请换一个链接，或直接填写产品介绍。", "未能讀取有效產品資料。請換一個連結，或直接填寫產品介紹。"],
  "We could not identify your products. Try another link or describe what you sell.": ["资料中未能识别到产品。请换一个链接，或直接介绍你销售什么。", "資料中未能識別到產品。請換一個連結，或直接介紹你銷售甚麼。"],
  "Checking that search criteria match your product changes…": ["正在核对搜索条件是否符合修改后的产品介绍…", "正在核對搜尋條件是否符合修改後的產品介紹…"],
  "Search criteria were updated to match your products. Review them below, then confirm.": ["已根据产品介绍更新搜索条件，请查看下方展开的内容后确认。", "已根據產品介紹更新搜尋條件，請查看下方展開的內容後確認。"],
  "Could not check product changes. Your edits are kept; please retry.": ["暂时无法核对产品变化，已保留你的修改，请重试。", "暫時無法核對產品變化，已保留你的修改，請重試。"],
  "Use an official company email or LinkedIn, or reveal a verified personal work email. You choose when to reach out.": ["使用官网公司邮箱或 LinkedIn，也可解锁已验证的个人工作邮箱。由你决定何时联系。", "使用官網公司信箱或 LinkedIn，也可解鎖已驗證的個人工作信箱。由你決定何時聯絡。"],
  "Official company emails are available without Reveal credits.": ["官网公开的公司邮箱无需消耗解锁额度。", "官網公開的公司信箱無需消耗解鎖額度。"],
  "Start with a company email": ["先从公司邮箱开始联系", "先從公司信箱開始聯絡"],
  "Click the company email to write a message. You can ask to be connected with the right buyer.": ["点击公司邮箱撰写邮件，可请对方转接相关采购负责人。", "點擊公司信箱撰寫郵件，可請對方轉接相關採購負責人。"],
  "Company contact entry points": ["公司联系入口", "公司聯絡入口"],
  "Company contact available": ["已有公司联系入口", "已有公司聯絡入口"],
  "Company email available · Further searches paused": ["公司邮箱可用 · 后续搜索已暂停", "公司信箱可用 · 後續搜尋已暫停"],
  "Last checked on the official website · {date}": ["上次官网确认 · {date}", "上次官網確認 · {date}"],
  "Official website · Company email": ["官网公开 · 公司邮箱", "官網公開 · 公司信箱"],
  "Shared mailbox. Personal ownership and deliverability have not been verified.": ["共用邮箱；尚未验证个人归属或可投递性。", "共用信箱；尚未驗證個人歸屬或可投遞性。"],
  "View official source": ["查看官网来源", "查看官網來源"],
  "Next search for a personal contact · {date}": ["下次寻找个人联系人 · {date}", "下次尋找個人聯絡人 · {date}"],
  "Personal contact not yet confirmed": ["个人联系人尚未确认", "個人聯絡人尚未確認"],
  "Relevant people first; official company mailboxes are also useful entry points.": ["优先寻找相关负责人，同时提供官网公开的公司邮箱。", "優先尋找相關負責人，同時提供官網公開的公司信箱。"],

  "Company update": ["公司动态", "公司動態"],
  "Company background · {count}": ["公司背景 · {count} 条", "公司背景 · {count} 則"],
  "Earlier activity and company capabilities. Kept for reference, not counted as new updates.": ["过往活动与公司能力，保留供参考，不计入新动态。", "過往活動與公司能力，保留供參考，不計入新動態。"],
  "Event date unconfirmed": ["事件日期待确认", "事件日期待確認"],
  "Discovery time in your timezone. Counts cover distinct updates for active companies; company background, earlier-focus and dismissed entries are excluded.": ["按你的本地发现时间统计正在关注公司的独立动态；不含公司背景、旧关注方向或已标为不相关的内容。", "按你的本地發現時間統計正在關注公司的獨立動態；不含公司背景、舊關注方向或已標為不相關的內容。"],
  "Recent updates": ["最近更新", "最近更新"],
  "Discovery period": ["发现时间范围", "發現時間範圍"],
  "Today": ["今天", "今天"],
  "Last 7 days": ["最近 7 天", "最近 7 天"],
  "{count} update": ["{count} 条新动态", "{count} 則新動態"],
  "{count} updates": ["{count} 条新动态", "{count} 則新動態"],
  "Needs confirmation · {count}": ["其中 {count} 条待核实", "其中 {count} 則待核實"],
  "No updates to review in this period.": ["这段时间暂无新动态可查看。", "這段時間暫無新動態可查看。"],
  "Companies checked today · {count}": ["今日已检查 · {count} 家公司", "今日已檢查 · {count} 家公司"],
  "Companies being checked · {count}": ["正在检查 · {count} 家公司", "正在檢查 · {count} 家公司"],
  "Checks needing attention · {count}": ["{count} 家公司的检查未完成", "{count} 家公司的檢查未完成"],
  "Companies due for checking · {count}": ["到期待检查 · {count} 家公司", "到期待檢查 · {count} 家公司"],
  "View updates": ["查看新动态", "查看新動態"],
  "Found today · {count}": ["今天新增 · {count} 条", "今天新增 · {count} 則"],
  "Discovered today · {time}": ["今天发现 · {time}", "今天發現 · {time}"],
  "Discovered · {date}": ["发现于 · {date}", "發現於 · {date}"],
  "Discovery time in your timezone. Counts cover the recent entries shown below for active companies; earlier-focus and dismissed entries are excluded.": ["按你的本地时间统计下方近期动态，仅包含正在关注的公司，不含旧关注方向或已标为不相关的内容。", "按你的本地時間統計下方近期動態，僅包含正在關注的公司，不含舊關注方向或已標為不相關的內容。"],
  "Email revealed": ["邮箱已解锁", "信箱已解鎖"],
  "View company and signals": ["查看公司与信号", "查看公司與訊號"],
  "Why this company": ["为什么联系这家公司", "為什麼聯絡這家公司"],
  "From your confirmed Market Brief": ["沿用已确认的市场简报", "沿用已確認的市場簡報"],
  "Your draft details": ["本次草稿信息", "本次草稿資訊"],
  "Review / edit details": ["查看或修改详情", "查看或修改詳情"],
  "Add the missing details to generate your draft.": ["补充缺少的信息，即可生成草稿。", "補充缺少的資訊，即可產生草稿。"],
  "Your company or brand was not recorded in the Brief. Add the name you represent.": ["简报尚未记录你的公司或品牌，请补充你所代表的名称。", "簡報尚未記錄你的公司或品牌，請補充你所代表的名稱。"],
  "Brief reference website": ["简报参考网站", "簡報參考網站"],
  "Saved drafts for {name}": ["{name} 的草稿", "{name} 的草稿"],
  "Saved in Mindstream. Nothing has been sent.": ["保存在 Mindstream 中，尚未发送。", "儲存在 Mindstream 中，尚未傳送。"],
  "No drafts for this contact yet. Generate one above; it will be saved here automatically.": ["这位联系人还没有草稿。在上方生成后，会自动保存在这里。", "這位聯絡人還沒有草稿。在上方產生後，會自動儲存在這裡。"],
  "Drafts for other contacts": ["其他联系人的草稿", "其他聯絡人的草稿"],
  "Saved": ["已保存", "已儲存"],
  "No verified email is available. You can still use LinkedIn outreach.": ["暂时没有可用的验证邮箱，仍可使用 LinkedIn 联系。", "暫時沒有可用的驗證信箱，仍可使用 LinkedIn 聯絡。"],
  "Refresh revealed email": ["刷新已解锁邮箱", "重新整理已解鎖信箱"],
  "Earlier edits saved. Your newest edits are still unsaved.": ["之前的修改已保存，最新输入仍未保存。", "之前的修改已儲存，最新輸入仍未儲存。"],
  "Discard local edits and reload": ["放弃本地修改并重新载入", "放棄本機修改並重新載入"],
  "Optional: save to Gmail": ["可选：保存到 Gmail", "可選：儲存到 Gmail"],
  "Creates a draft in the account you choose. Nothing is sent; existing Gmail edits are preserved.": ["在你选定的账号中创建草稿，不会发送，也不会覆盖 Gmail 中的编辑。", "在你選定的帳號中建立草稿，不會傳送，也不會覆蓋 Gmail 中的編輯。"],
  "Gmail connection is not configured yet. Copy your draft to use it anywhere.": ["Gmail 连接尚未配置，你可以复制草稿到任意邮箱使用。", "Gmail 連線尚未設定，你可以複製草稿到任意信箱使用。"],
  "Choose another Gmail account": ["选择其他 Gmail 账号", "選擇其他 Gmail 帳號"],
  "Choose a Gmail account": ["选择 Gmail 账号", "選擇 Gmail 帳號"],
  "Gmail account": ["Gmail 账号", "Gmail 帳號"],
  "Save draft to this Gmail account": ["保存草稿到此 Gmail 账号", "儲存草稿到此 Gmail 帳號"],
  "Open Gmail drafts": ["打开 Gmail 草稿箱", "開啟 Gmail 草稿匣"],
  "Gmail authorization is unavailable.": ["Gmail 授权暂不可用。", "Gmail 授權暫時無法使用。"],
  "Gmail authorization was cancelled.": ["已取消 Gmail 授权。", "已取消 Gmail 授權。"],
  "Gmail draft permission is required.": ["需要 Gmail 草稿权限。", "需要 Gmail 草稿權限。"],
  "Reconnect Gmail and confirm the account before saving.": ["请重新连接 Gmail，确认账号后再保存。", "請重新連線 Gmail，確認帳號後再儲存。"],
  "Gmail save could not be confirmed. Retry to look for the original draft, or check Gmail. No duplicate will be created.": ["无法确认 Gmail 保存结果。重试会查找原草稿，也可以直接检查 Gmail，不会重复创建。", "無法確認 Gmail 儲存結果。重試會尋找原草稿，也可以直接檢查 Gmail，不會重複建立。"],
  "Start a useful conversation.": ["开启有价值的对话。", "開啟有價值的對話。"],
  "Use LinkedIn directly, or reveal a verified work email. You stay in control of every message.": ["直接使用 LinkedIn，或解锁已验证的工作邮箱。每条消息都由你决定。", "直接使用 LinkedIn，或解鎖已驗證的工作信箱。每則訊息都由你決定。"],
  "Reveal credits": ["解锁额度", "解鎖額度"],
  "Prepared contacts": ["已准备的联系人", "已準備的聯絡人"],
  "One credit per verified email. Repeat reveals are free.": ["每个验证邮箱消耗 1 个额度，重复查看不再扣费。", "每個驗證信箱消耗 1 個額度，重複查看不再扣費。"],
  "Your watched companies will appear here when a contact channel is ready.": ["关注公司的联系渠道准备好后，会显示在这里。", "關注公司的聯絡管道準備好後，會顯示在這裡。"],
  "Open Watch": ["打开关注列表", "開啟關注清單"],
  "Verified email": ["已验证邮箱", "已驗證信箱"],
  "Revealed emails": ["已解锁邮箱", "已解鎖信箱"],
  "Current verified email": ["当前验证有效", "目前驗證有效"],
  "Saved receipt — current availability needs checking": ["历史记录，当前有效性待确认", "歷史紀錄，目前有效性待確認"],
  "Copy email": ["复制邮箱", "複製信箱"],
  "Contact channel": ["联系渠道", "聯絡管道"],
  "Email": ["邮件", "郵件"],
  "A short LinkedIn opener": ["简短的 LinkedIn 开场白", "簡短的 LinkedIn 開場白"],
  "A personal email introduction": ["有针对性的邮件介绍", "有針對性的郵件介紹"],
  "Verified work email ready. Reveal it for 1 credit; further access to this contact is free.": ["工作邮箱已验证。花 1 个额度解锁此联系人，之后查看不再扣费。", "工作信箱已驗證。花 1 個額度解鎖此聯絡人，之後查看不再扣費。"],
  "Reveal email · 1 credit": ["解锁邮箱 · 1 个额度", "解鎖信箱 · 1 個額度"],
  "Ask your pilot contact for credits. Online purchase is not available yet.": ["请联系试点负责人获取额度，暂未开放在线购买。", "請聯絡試點負責人取得額度，暫未開放線上購買。"],
  "To": ["收件人", "收件人"],
  "Your name": ["你的姓名", "你的姓名"],
  "Your company": ["你的公司", "你的公司"],
  "What you can credibly offer": ["你能提供什么", "你能提供什麼"],
  "Products, capabilities and supporting proof you can stand behind.": ["填写真实的产品、能力和可以提供的证明。", "填寫真實的產品、能力和可以提供的證明。"],
  "Your next-step request": ["希望对方采取的下一步", "希望對方採取的下一步"],
  "For example: a brief call about distribution fit": ["例如：简短交流，了解经销合作是否合适", "例如：簡短交流，了解經銷合作是否合適"],
  "Draft language": ["草稿语言", "草稿語言"],
  "Tone": ["语气", "語氣"],
  "Concise": ["简洁", "簡潔"],
  "Warm": ["亲切", "親切"],
  "Formal": ["正式", "正式"],
  "Signature": ["签名", "簽名"],
  "Create a new draft": ["生成新草稿", "產生新草稿"],
  "Draft generation uses no Reveal credits. Review every claim before contacting the buyer.": ["生成草稿不消耗解锁额度。联系买家前，请核对每项表述。", "產生草稿不消耗解鎖額度。聯絡買家前，請核對每項表述。"],
  "Choose a prepared contact": ["选择已准备的联系人", "選擇已準備的聯絡人"],
  "LinkedIn openers work without purchasing an email.": ["无需购买邮箱即可使用 LinkedIn 开场白。", "無需購買信箱即可使用 LinkedIn 開場白。"],
  "Your editable draft": ["可编辑草稿", "可編輯草稿"],
  "Generation failed. Create a new draft to try again.": ["生成失败，请生成新草稿重试。", "產生失敗，請產生新草稿重試。"],
  "This request is still processing. Refresh saved drafts to recover the result.": ["请求仍在处理中，请刷新已保存草稿查看结果。", "請求仍在處理中，請重新整理已儲存草稿查看結果。"],
  "Subject": ["主题", "主旨"],
  "Message": ["正文", "內文"],
  "Copy draft": ["复制草稿", "複製草稿"],
  "Unsaved changes — save before switching drafts or contacts.": ["有未保存的修改，请先保存再切换草稿或联系人。", "有未儲存的修改，請先儲存再切換草稿或聯絡人。"],
  "Sources used": ["使用的来源", "使用的來源"],
  "Occurred": ["已发生", "已發生"],
  "Source": ["来源", "來源"],
  "Saved drafts": ["已保存草稿", "已儲存草稿"],
  "Refresh saved drafts": ["刷新已保存草稿", "重新整理已儲存草稿"],
  "Generation failed": ["生成失败", "產生失敗"],
  "Generating": ["生成中", "產生中"],
  "Draft saved.": ["草稿已保存。", "草稿已儲存。"],
  "Copied.": ["已复制。", "已複製。"],
  "Start outreach": ["开始联系", "開始聯絡"],
  "This contact has no current verified email. No credit was used.": ["此联系人暂无有效验证邮箱，未扣除额度。", "此聯絡人暫無有效驗證信箱，未扣除額度。"],
  "You need one Radar credit to reveal this email.": ["需要 1 个雷达额度才能解锁此邮箱。", "需要 1 個雷達額度才能解鎖此信箱。"],
  "This contact channel is no longer current. Refresh your Watch list.": ["此联系渠道已失效，请刷新关注列表。", "此聯絡管道已失效，請重新整理關注清單。"],
  "Reveal the email before creating an email draft.": ["请先解锁邮箱，再生成邮件草稿。", "請先解鎖信箱，再產生郵件草稿。"],
  "This draft changed in another session. Reload it before saving.": ["草稿已在其他会话中修改，请先重新载入再保存。", "草稿已在其他工作階段中修改，請先重新載入再儲存。"],
  "The daily draft limit has been reached. Try again tomorrow.": ["已达到每日草稿生成上限，请明天再试。", "已達到每日草稿產生上限，請明天再試。"],
  "The draft could not be generated. Your Reveal credits are unchanged.": ["草稿生成失败，解锁额度未受影响。", "草稿產生失敗，解鎖額度未受影響。"],
  "Act is temporarily unavailable. Please try again.": ["联系功能暂时不可用，请重试。", "聯絡功能暫時無法使用，請重試。"],
  "Unconfirmed summary:": ["待确认摘要：", "待確認摘要："],
  "Language": [
    "语言",
    "語言"
  ],
  "Buyer Radar": [
    "买家雷达",
    "買家雷達"
  ],
  "Market Brief": [
    "市场简报",
    "市場簡報"
  ],
  "Market Brief ·": [
    "市场简报 ·",
    "市場簡報 ·"
  ],
  "Your Market Brief": [
    "你的市场简报",
    "你的市場簡報"
  ],
  "Understand": [
    "了解需求",
    "了解需求"
  ],
  "Understand ·": [
    "了解需求 ·",
    "了解需求 ·"
  ],
  "Discover": [
    "发现买家",
    "尋找買家"
  ],
  "Discover ·": [
    "发现买家 ·",
    "尋找買家 ·"
  ],
  "Watch": [
    "关注",
    "關注"
  ],
  "Act": [
    "联系买家",
    "聯絡買家"
  ],
  "Workspace": [
    "工作区",
    "工作區"
  ],
  "Coming next": [
    "即将推出",
    "即將推出"
  ],
  "Private workspace": [
    "私人工作区",
    "私人工作區"
  ],
  "Merchant workspace": [
    "商家工作区",
    "商家工作區"
  ],
  "Pilot workspace": [
    "试用工作区",
    "試用工作區"
  ],
  "Use any email address. Verify it to start your free trial.": ["使用任意邮箱，验证后即可开始免费试用。", "使用任意電郵，驗證後即可開始免費試用。"],
  "Free credits are granted once. No payment details are required. Returning users keep their existing workspace.": ["免费额度只发放一次，无需提供付款信息。再次登录将回到原有工作台。", "免費額度只發放一次，無需提供付款資料。再次登入將回到原有工作台。"],
  "or use your email": ["或使用邮箱", "或使用電郵"],
  "Please try again. If this continues, contact support.": ["请重试；如仍无法进入，请联系支持。", "請重試；如仍無法進入，請聯絡支援。"],
  "Your workspace could not be opened yet. Please try again shortly.": ["工作台暂时无法打开，请稍后重试。", "工作台暫時無法開啟，請稍後重試。"],
  "Buyer Radar access for this account is inactive. Please contact support.": ["此账号的 Buyer Radar 访问权限已停用，请联系支持。", "此帳號的 Buyer Radar 存取權限已停用，請聯絡支援。"],
  "Private pilot workspace": [
    "私人试用工作区",
    "私人試用工作區"
  ],
  "Buyer Radar workspace": [
    "买家雷达工作区",
    "買家雷達工作區"
  ],
  "Buyer Radar workflow": [
    "买家雷达流程",
    "買家雷達流程"
  ],
  "Buyer Radar Workspace | Mindstream": [
    "买家雷达工作区 | Mindstream",
    "買家雷達工作區 | Mindstream"
  ],
  "Shape the brief": [
    "确认市场简报",
    "確認市場簡報"
  ],
  "Find evidence": [
    "查看依据",
    "查看依據"
  ],
  "Monitor change": [
    "关注变化",
    "關注變化"
  ],
  "Reach the buyer": [
    "联系目标买家",
    "聯絡目標買家"
  ],
  "Find the buyer.": [
    "找到买家。",
    "找到買家。"
  ],
  "See the reason.": [
    "看清依据。",
    "看清依據。"
  ],
  "Choose the next move.": [
    "决定下一步。",
    "決定下一步。"
  ],
  "Your radar begins with a brief you can challenge—not a black-box list of leads.": [
    "从一份由你审核的市场简报开始，让每个买家推荐都有清楚的依据。",
    "從一份由你審核的市場簡報開始，讓每個買家推薦都有清楚的依據。"
  ],
  "No Gmail access required": [
    "无需授权 Gmail",
    "無需授權 Gmail"
  ],
  "01 / ACCESS": [
    "01 / 登录",
    "01 / 登入"
  ],
  "Open your workspace": [
    "打开你的工作区",
    "開啟你的工作區"
  ],
  "Use the email address invited to the Buyer Radar pilot.": [
    "请使用受邀试用买家雷达的邮箱。",
    "請使用受邀試用買家雷達的電郵地址。"
  ],
  "Continue with Google": [
    "使用 Google 继续",
    "使用 Google 繼續"
  ],
  "or use a business email": [
    "或使用工作邮箱",
    "或使用工作電郵"
  ],
  "Work email": [
    "工作邮箱",
    "工作電郵"
  ],
  "Email me a sign-in link": [
    "发送登录链接",
    "傳送登入連結"
  ],
  "Send verification code": ["发送验证码", "傳送驗證碼"],
  "Verification code": ["验证码", "驗證碼"],
  "Verify and sign in": ["验证并登录", "驗證並登入"],
  "Resend code": ["重新发送验证码", "重新傳送驗證碼"],
  "Resend in {seconds}s": ["{seconds} 秒后可重发", "{seconds} 秒後可重傳"],
  "Use a different email": ["使用其他邮箱", "使用其他電郵"],
  "Enter the code sent to {email}": ["请输入发送至 {email} 的验证码", "請輸入傳送至 {email} 的驗證碼"],
  "Check your inbox for a six-digit verification code.": ["请查收邮件中的六位验证码。", "請查收電郵中的六位驗證碼。"],
  "Could not send the verification code. Please try again.": ["验证码发送失败，请重试。", "驗證碼傳送失敗，請重試。"],
  "This code is invalid or has expired. Try again or request a new code.": ["验证码无效或已过期，请重试或重新获取验证码。", "驗證碼無效或已過期，請重試或重新取得驗證碼。"],
  "Could not sign in. Please try again.": ["登录失败，请重试。", "登入失敗，請重試。"],
  "Signed in. Opening your workspace…": ["已登录，正在打开工作区…", "已登入，正在開啟工作區…"],
  "This sign-in link is invalid or has expired. Request an email verification code below.": ["此登录链接无效或已过期，请在下方获取邮箱验证码。", "此登入連結無效或已過期，請在下方取得電郵驗證碼。"],
  "Sign-in could not be completed. Please try signing in again.": ["未能完成登录，请重新登录。", "未能完成登入，請重新登入。"],
  "Check your inbox for a secure sign-in link.": [
    "请查收邮箱中的安全登录链接。",
    "請查收電郵中的安全登入連結。"
  ],
  "Access is limited to invited pilot accounts. Signing in does not grant access to the Chrome extension.": [
    "仅限受邀试用账号使用。登录不会同时开通 Chrome 扩展权限。",
    "僅限受邀試用帳號使用。登入不會同時開通 Chrome 擴充功能權限。"
  ],
  "Could not start sign-in.": [
    "暂时无法登录，请重试。",
    "暫時無法登入，請重試。"
  ],
  "Could not send the sign-in link.": [
    "登录链接发送失败，请重试。",
    "登入連結傳送失敗，請重試。"
  ],
  "Let’s build a first hypothesis about your market.": [
    "先明确你的目标市场和买家。",
    "先明確你的目標市場和買家。"
  ],
  "Start with one product page and two pieces of direction. We will draft the Market Brief; you stay in control of what is right.": [
    "提供一个产品页面，以及目标市场和买家方向。我们会起草市场简报，由你审核确认。",
    "提供一個產品頁面，以及目標市場和買家方向。我們會起草市場簡報，由你審核確認。"
  ],
  "Company or product page": [
    "公司或产品页面",
    "公司或產品頁面"
  ],
  "Target market": [
    "目标市场",
    "目標市場"
  ],
  "Who do you hope to find?": [
    "你希望找到谁？",
    "你希望找到誰？"
  ],
  "e.g. Vietnam": [
    "例如：越南",
    "例如：越南"
  ],
  "e.g. implementation distributor": [
    "例如：具备实施能力的分销商",
    "例如：具備實施能力的分銷商"
  ],
  "Anything we should know?": [
    "还有什么需要了解？",
    "還有甚麼需要了解？"
  ],
  "Optional": [
    "选填",
    "選填"
  ],
  "Your strongest product line, channel constraints, or who is not a fit…": [
    "你的优势产品、渠道要求，或需要排除的买家类型…",
    "你的優勢產品、渠道要求，或需要排除的買家類型…"
  ],
  "Draft my Market Brief": [
    "生成市场简报",
    "產生市場簡報"
  ],
  "Reading your page and drafting…": [
    "正在阅读页面并起草…",
    "正在閱讀頁面並起草…"
  ],
  "Reading your product page and building your Market Brief…": [
    "正在阅读产品页面并生成市场简报…",
    "正在閱讀產品頁面並產生市場簡報…"
  ],
  "This can take about a minute. You can stay here; the next step opens automatically.": [
    "可能需要约一分钟。请留在此页，完成后会自动进入下一步。",
    "可能需要約一分鐘。請留在此頁，完成後會自動進入下一步。"
  ],
  "You can write in English, Simplified Chinese, Traditional Chinese or Cantonese.": [
    "可以使用英语、简体中文、繁体中文或粤语填写。",
    "可以使用英語、簡體中文、繁體中文或粵語填寫。"
  ],
  "This is what we understand about your growth target. Is it right?": [
    "这是我们对你业务拓展目标的理解，准确吗？",
    "這是我們對你業務拓展目標的理解，準確嗎？"
  ],
  "This is a starting point, not a verdict. Correct it before the radar looks for companies.": [
    "这是一份待确认的初稿。请先修正，再开始寻找公司。",
    "這是一份待確認的初稿。請先修正，再開始尋找公司。"
  ],
  "Save changes for your next search. Your existing companies and feedback stay in Discover.": [
    "保存后用于下一次搜索。已发现的公司和反馈会继续保留。",
    "儲存後用於下一次搜尋。已發現的公司和回饋會繼續保留。"
  ],
  "Needs your review": [
    "待你确认",
    "待你確認"
  ],
  "your direction": [
    "你的方向",
    "你的方向"
  ],
  "hypothesis": [
    "初步假设",
    "初步假設"
  ],
  "What do you sell?": [
    "你销售什么？",
    "你銷售甚麼？"
  ],
  "Describe the offer a buyer would actually evaluate.": [
    "描述买家需要评估的具体产品或服务。",
    "描述買家需要評估的具體產品或服務。"
  ],
  "Where do you want to grow?": [
    "你想拓展哪个市场？",
    "你想拓展哪個市場？"
  ],
  "One focused market is enough for the first scan.": [
    "首次搜索先聚焦一个市场即可。",
    "首次搜尋先聚焦一個市場即可。"
  ],
  "Who do you need to win first?": [
    "你需要先争取哪类客户？",
    "你需要先爭取哪類客戶？"
  ],
  "For example: a distributor with hospital access.": [
    "例如：拥有医院渠道的分销商。",
    "例如：擁有醫院渠道的分銷商。"
  ],
  "What relationship are you trying to build?": [
    "你希望建立什么合作关系？",
    "你希望建立甚麼合作關係？"
  ],
  "Review search assumptions": [
    "查看搜索假设",
    "查看搜尋假設"
  ],
  "Products": [
    "产品",
    "產品"
  ],
  "Required capabilities": [
    "必备能力",
    "必備能力"
  ],
  "Exclude": [
    "排除条件",
    "排除條件"
  ],
  "Signals to look for": [
    "需要关注的信号",
    "需要關注的訊號"
  ],
  "Please pressure-test these assumptions": [
    "请核对以下假设是否合理",
    "請核對以下假設是否合理"
  ],
  "Confirm and build my radar": [
    "确认并建立我的雷达",
    "確認並建立我的雷達"
  ],
  "Save changes": [
    "保存修改",
    "儲存修改"
  ],
  "Discard changes": [
    "放弃修改",
    "放棄修改"
  ],
  "Saving your Market Brief…": [
    "正在保存市场简报…",
    "正在儲存市場簡報…"
  ],
  "Saving does not use a search.": [
    "保存不会消耗搜索次数。",
    "儲存不會消耗搜尋次數。"
  ],
  "Your brief stays editable after confirmation.": [
    "确认后仍可修改简报。",
    "確認後仍可修改簡報。"
  ],
  "Companies worth a closer look": [
    "值得进一步了解的公司",
    "值得進一步了解的公司"
  ],
  "Fit Candidate means the company matches your brief. Buyer Moment adds a timely, source-backed reason to act now.": [
    "匹配公司符合你的市场简报；商机时刻还包含近期、有来源支持的行动理由。",
    "匹配公司符合你的市場簡報；商機時刻還包含近期、有來源支持的行動理由。"
  ],
  "Fit Candidate": [
    "匹配公司",
    "匹配公司"
  ],
  "Buyer Moment": [
    "商机时刻",
    "商機時刻"
  ],
  "Buyer moment": [
    "商机时刻",
    "商機時刻"
  ],
  "New this search": [
    "本次新发现",
    "本次新發現"
  ],
  "Found again": [
    "再次发现",
    "再次發現"
  ],
  "From an earlier search": [
    "之前发现",
    "之前發現"
  ],
  "Why it may fit you": [
    "为什么可能适合你",
    "為甚麼可能適合你"
  ],
  "What changed": [
    "发生了什么变化",
    "發生了甚麼變化"
  ],
  "No timely trigger passed our evidence check yet.": [
    "暂未找到通过证据核验的近期触发事件。",
    "暫未找到通過證據核驗的近期觸發事件。"
  ],
  "This company fits the brief, but timing still needs watching.": [
    "这家公司符合简报要求，合作时机还需关注。",
    "這家公司符合簡報要求，合作時機還需關注。"
  ],
  "Relevant": [
    "相关",
    "相關"
  ],
  "Not a fit": [
    "不匹配",
    "不匹配"
  ],
  "Marked relevant": [
    "已标记相关",
    "已標記相關"
  ],
  "Marked not a fit": [
    "已标记不匹配",
    "已標記不匹配"
  ],
  " · Watch paused; Undo changes feedback only.": [
    " · 已暂停关注；撤销只会修改反馈。",
    " · 已暫停關注；撤銷只會修改回饋。"
  ],
  "Help the next search learn": [
    "帮助改进下一次搜索",
    "幫助改善下一次搜尋"
  ],
  "Undo": [
    "撤销",
    "撤銷"
  ],
  "Cancel": [
    "取消",
    "取消"
  ],
  "What looks right?": [
    "哪些方面匹配？",
    "哪些方面匹配？"
  ],
  "What is off?": [
    "哪些方面不匹配？",
    "哪些方面不匹配？"
  ],
  "Right kind of buyer": [
    "买家类型合适",
    "買家類型合適"
  ],
  "Right market": [
    "市场合适",
    "市場合適"
  ],
  "Strong channel capabilities": [
    "渠道能力强",
    "渠道能力強"
  ],
  "Good timing": [
    "时机合适",
    "時機合適"
  ],
  "Wrong kind of buyer": [
    "买家类型不符",
    "買家類型不符"
  ],
  "Wrong market": [
    "市场不符",
    "市場不符"
  ],
  "Cannot sell through this channel": [
    "无法通过此渠道销售",
    "無法透過此渠道銷售"
  ],
  "Too large for us": [
    "规模过大",
    "規模過大"
  ],
  "Already a customer": [
    "已经是客户",
    "已經是客戶"
  ],
  "Evidence is too weak": [
    "证据不足",
    "證據不足"
  ],
  "Anything else?": [
    "还有其他反馈？",
    "還有其他回饋？"
  ],
  "Save feedback": [
    "保存反馈",
    "儲存回饋"
  ],
  "No searches remaining": [
    "搜索次数已用完",
    "搜尋次數已用完"
  ],
  "Search again with what we learned": [
    "根据反馈再次搜索",
    "根據回饋再次搜尋"
  ],
  "You have unsaved Brief changes.": [
    "你有尚未保存的简报修改。",
    "你有尚未儲存的簡報修改。"
  ],
  "Save them before your next search. Your existing results are still here.": [
    "请先保存再搜索。现有结果会继续保留。",
    "請先儲存再搜尋。現有結果會繼續保留。"
  ],
  "Review changes": [
    "查看修改",
    "查看修改"
  ],
  "{count} companies in your workspace": [
    "工作区中有 {count} 家公司",
    "工作區中有 {count} 家公司"
  ],
  "Latest completed search: {new} new · {seen} found again. Earlier companies and your feedback stay here.": [
    "最近一次完成的搜索：新发现 {new} 家，再次发现 {seen} 家。之前的公司和反馈继续保留。",
    "最近一次完成的搜尋：新發現 {new} 家，再次發現 {seen} 家。之前的公司和回饋繼續保留。"
  ],
  "{count} searches remaining": [
    "剩余 {count} 次搜索",
    "剩餘 {count} 次搜尋"
  ],
  "{count} pilot searches remaining": [
    "剩余 {count} 次试用搜索",
    "剩餘 {count} 次試用搜尋"
  ],
  "1 search looks for multiple companies.": [
    "每次搜索会寻找多家公司。",
    "每次搜尋會尋找多家公司。"
  ],
  "Starting your search…": [
    "正在开始搜索…",
    "正在開始搜尋…"
  ],
  "Scanning for evidence-backed buyers…": [
    "正在寻找有证据支持的买家…",
    "正在尋找有證據支持的買家…"
  ],
  "This can take about a minute. Your previous results stay visible while this runs.": [
    "可能需要约一分钟。搜索期间仍可查看已有结果。",
    "可能需要約一分鐘。搜尋期間仍可查看已有結果。"
  ],
  "The latest scan did not finish.": [
    "最近一次搜索未完成。",
    "最近一次搜尋未完成。"
  ],
  "Your previous results are still available.": [
    "之前的结果仍可查看。",
    "之前的結果仍可查看。"
  ],
  "Try again": [
    "重试",
    "重試"
  ],
  "Brief confirmed": [
    "简报已确认",
    "簡報已確認"
  ],
  "No companies passed the evidence check this time.": [
    "本次没有公司通过证据核验。",
    "本次沒有公司通過證據核驗。"
  ],
  "Ready to build your first radar.": [
    "可以开始第一次搜索了。",
    "可以開始第一次搜尋了。"
  ],
  "We will search for companies that fit your channel requirements, then keep only claims supported by readable source evidence.": [
    "我们会寻找符合你渠道要求的公司，并只保留有可查阅来源支持的信息。",
    "我們會尋找符合你渠道要求的公司，並只保留有可查閱來源支持的資訊。"
  ],
  "Search again": [
    "再次搜索",
    "再次搜尋"
  ],
  "Find my first buyers": [
    "寻找第一批买家",
    "尋找第一批買家"
  ],
  "Watch · your selected companies": [
    "关注 · 你选择的公司",
    "關注 · 你選擇的公司"
  ],
  "Keep the right companies in view.": [
    "持续关注合适的公司。",
    "持續關注合適的公司。"
  ],
  "Company, project and people changes, checked daily. Contacts are prepared only for companies you Watch.": [
    "每日检查公司、项目和人员变化。只为你关注的公司准备联系人。",
    "每日檢查公司、專案和人員變化。只為你關注的公司準備聯絡人。"
  ],
  "{active} of {limit} companies": [
    "已关注 {active} / {limit} 家公司",
    "已關注 {active} / {limit} 家公司"
  ],
  "Your Market Brief changed.": [
    "你的市场简报已更改。",
    "你的市場簡報已更改。"
  ],
  "Review these companies for your new direction. You can keep them together or decide individually below.": [
    "请按新方向核对这些公司，可以全部继续关注，也可以逐一决定。",
    "請按新方向核對這些公司，可以全部繼續關注，也可以逐一決定。"
  ],
  "Keep watching {count} companies": [
    "继续关注这 {count} 家公司",
    "繼續關注這 {count} 家公司"
  ],
  "What your radar is watching for": [
    "雷达正在关注什么",
    "雷達正在關注甚麼"
  ],
  "Adjust focus": [
    "调整关注重点",
    "調整關注重點"
  ],
  "Based on your Market Brief and shared by all companies you Watch. Each check also considers the company's own background.": [
    "根据你的市场简报设定，适用于所有关注的公司。每次检查也会结合公司的自身背景。",
    "根據你的市場簡報設定，適用於所有關注的公司。每次檢查也會結合公司的自身背景。"
  ],
  "Commercial focus": [
    "业务关注重点",
    "業務關注重點"
  ],
  "Changes to look for · one per line": [
    "关注的变化 · 每行一项",
    "關注的變化 · 每行一項"
  ],
  "People and responsibilities": [
    "人员与职责",
    "人員與職責"
  ],
  "Changes apply to future checks. To change your product, market or target buyer, update the Market Brief.": [
    "修改将用于后续检查。如需更改产品、市场或买家类型，请修改市场简报。",
    "修改將用於後續檢查。如需更改產品、市場或買家類型，請修改市場簡報。"
  ],
  "Save monitoring focus": [
    "保存关注重点",
    "儲存關注重點"
  ],
  "Your Watch list starts with a company.": [
    "从关注一家公司开始。",
    "從關注一家公司開始。"
  ],
  "Choose Watch on a company in Discover to begin monitoring and contact preparation.": [
    "在发现买家中选择一家公司的“关注”，即可开始监测和联系人准备。",
    "在尋找買家中選擇一家公司的「關注」，即可開始監測和聯絡人準備。"
  ],
  "Choose companies": [
    "选择公司",
    "選擇公司"
  ],
  "Selected company": [
    "已选公司",
    "已選公司"
  ],
  "Watching daily": [
    "每日关注中",
    "每日關注中"
  ],
  "Review your new direction": [
    "核对新的方向",
    "核對新的方向"
  ],
  "Paused": [
    "已暂停",
    "已暫停"
  ],
  "Company website": [
    "公司网站",
    "公司網站"
  ],
  "Open {name} website": [
    "打开 {name} 的网站",
    "開啟 {name} 的網站"
  ],
  "Watch {name}": [
    "关注 {name}",
    "關注 {name}"
  ],
  "Pause {name}": [
    "暂停关注 {name}",
    "暫停關注 {name}"
  ],
  "Resume {name}": [
    "恢复关注 {name}",
    "恢復關注 {name}"
  ],
  "Pause": [
    "暂停",
    "暫停"
  ],
  "Resume": [
    "恢复",
    "恢復"
  ],
  "Keep watching": [
    "继续关注",
    "繼續關注"
  ],
  "Watching": [
    "关注中",
    "關注中"
  ],
  "Resume Watch": [
    "恢复关注",
    "恢復關注"
  ],
  "Paused after Not Fit. Undo changes the feedback; resume here when you want to watch again.": [
    "标记不匹配后已暂停关注。撤销只修改反馈；需要继续关注时，请在这里恢复。",
    "標記不匹配後已暫停關注。撤銷只修改回饋；需要繼續關注時，請在這裡恢復。"
  ],
  "Your Market Brief changed. Confirm that this company still fits before checks and contact preparation resume.": [
    "市场简报已更改。请确认这家公司仍然适合，再恢复检查和联系人准备。",
    "市場簡報已更改。請確認這家公司仍然適合，再恢復檢查和聯絡人準備。"
  ],
  "Signals": [
    "信号",
    "訊號"
  ],
  "Contacts": [
    "联系人",
    "聯絡人"
  ],
  "Monitoring paused": [
    "监测已暂停",
    "監測已暫停"
  ],
  "Preparation paused": [
    "准备已暂停",
    "準備已暫停"
  ],
  "Waiting for the next scheduled check": [
    "等待下一次定时检查",
    "等待下一次定時檢查"
  ],
  "Checking sources": [
    "正在检查来源",
    "正在檢查來源"
  ],
  "No new signals": [
    "暂无新信号",
    "暫無新訊號"
  ],
  "Check completed": [
    "检查已完成",
    "檢查已完成"
  ],
  "Some sources could not be checked": [
    "部分来源未能检查",
    "部分來源未能檢查"
  ],
  "Check did not finish": [
    "检查未完成",
    "檢查未完成"
  ],
  "Next check deferred — daily allowance reached": [
    "已达到每日额度，检查稍后继续",
    "已達到每日額度，檢查稍後繼續"
  ],
  "Check status unavailable": [
    "暂无检查状态",
    "暫無檢查狀態"
  ],
  "Contact allowance reached — preparation will retry after it renews": [
    "已达到联系人额度，恢复额度后重试",
    "已達到聯絡人額度，恢復額度後重試"
  ],
  "Contact channels prepared": [
    "联系渠道已准备好",
    "聯絡渠道已準備好"
  ],
  "No contact channels found yet": [
    "暂未找到联系渠道",
    "暫未找到聯絡渠道"
  ],
  "Contact channels need refreshing": [
    "联系渠道需要更新",
    "聯絡渠道需要更新"
  ],
  "Some contact sources could not be checked": [
    "部分联系人来源未能检查",
    "部分聯絡人來源未能檢查"
  ],
  "Checking relevant people and contact channels": [
    "正在核对相关人员和联系渠道",
    "正在核對相關人員和聯絡渠道"
  ],
  "Contact preparation did not finish": [
    "联系人准备未完成",
    "聯絡人準備未完成"
  ],
  "Preparation deferred — daily allowance reached": [
    "已达到每日额度，准备稍后继续",
    "已達到每日額度，準備稍後繼續"
  ],
  "Contact preparation queued": [
    "联系人准备已排队",
    "聯絡人準備已排隊"
  ],
  "Contact status unavailable": [
    "暂无联系人状态",
    "暫無聯絡人狀態"
  ],
  "No completed check yet": [
    "暂无已完成的检查",
    "暫無已完成的檢查"
  ],
  "Check time unavailable": [
    "暂无检查时间",
    "暫無檢查時間"
  ],
  "Last successful check · {date}": [
    "上次成功检查 · {date}",
    "上次成功檢查 · {date}"
  ],
  "Up to 3 relevant people, with a matched LinkedIn profile or verified work email.": [
    "最多提供 3 位相关人员，具备已匹配的 LinkedIn 资料或已验证的工作邮箱。",
    "最多提供 3 位相關人員，具備已匹配的 LinkedIn 資料或已驗證的工作電郵。"
  ],
  "Signals for {name}": [
    "{name} 的信号",
    "{name} 的訊號"
  ],
  "Contacts for {name}": [
    "{name} 的联系人",
    "{name} 的聯絡人"
  ],
  "Feedback on {name}": [
    "关于 {name} 的反馈",
    "關於 {name} 的回饋"
  ],
  "Earlier monitoring focus": [
    "之前的关注重点",
    "之前的關注重點"
  ],
  "Company context": [
    "公司背景",
    "公司背景"
  ],
  "Event": [
    "事件日期",
    "事件日期"
  ],
  "Reported date · unconfirmed": [
    "报道日期 · 未确认",
    "報道日期 · 未確認"
  ],
  "Event date not established": [
    "事件日期尚未确定",
    "事件日期尚未確定"
  ],
  "Why this may matter": [
    "为什么可能值得关注",
    "為甚麼可能值得關注"
  ],
  "Read the source": [
    "查看来源",
    "查看來源"
  ],
  "Does this help?": [
    "这条信息有帮助吗？",
    "這則資訊有幫助嗎？"
  ],
  "Useful": [
    "有帮助",
    "有幫助"
  ],
  "Not relevant": [
    "不相关",
    "不相關"
  ],
  "Saved ·": [
    "已保存 ·",
    "已儲存 ·"
  ],
  "People to approach": [
    "可以联系的人员",
    "可以聯絡的人員"
  ],
  "Open LinkedIn": [
    "打开 LinkedIn",
    "開啟 LinkedIn"
  ],
  "LinkedIn profile matched ·": [
    "LinkedIn 资料已匹配 ·",
    "LinkedIn 資料已匹配 ·"
  ],
  "Work email verified ·": [
    "工作邮箱已验证 ·",
    "工作電郵已驗證 ·"
  ],
  "Email source ·": [
    "邮箱来源 ·",
    "電郵來源 ·"
  ],
  "Public source": [
    "公开来源",
    "公開來源"
  ],
  "Data provider": [
    "数据供应商",
    "資料供應商"
  ],
  "Role source": [
    "职位依据",
    "職位依據"
  ],
  "Something went wrong. Please try again.": [
    "操作未完成，请重试。",
    "操作未完成，請重試。"
  ],
  "Connection interrupted. Please try again.": [
    "连接中断，请重试。",
    "連線中斷，請重試。"
  ],
  "Connection interrupted. Check your connection and try again. We could not confirm the result.": [
    "连接中断，暂时无法确认操作结果。请检查网络后重试。",
    "連線中斷，暫時無法確認操作結果。請檢查網路後重試。"
  ],
  "Your session needs refreshing. Reconnect to check access again; your current work stays on this page.": [
    "登录状态需要刷新。请重新连接以核对权限，当前内容会保留在此页。",
    "登入狀態需要重新整理。請重新連線以核對權限，目前內容會保留在此頁。"
  ],
  "Access is no longer available for this account or workspace.": [
    "此账号或工作区已无访问权限。",
    "此帳號或工作區已無存取權限。"
  ],
  "This search is taking longer than expected. Refresh to check its status; your previous results remain available.": [
    "搜索用时较长。请刷新查看进度，已有结果仍可查看。",
    "搜尋用時較長。請重新整理查看進度，已有結果仍可查看。"
  ],
  "Reconnecting… Your search may still be running. We will check again automatically.": [
    "正在重新连接…搜索可能仍在进行，我们会自动检查进度。",
    "正在重新連線…搜尋可能仍在進行，我們會自動檢查進度。"
  ],
  "Could not refresh Watch. Your saved results remain here; checking again shortly.": [
    "暂时无法更新关注列表。已保存的结果仍在，我们会稍后重试。",
    "暫時無法更新關注清單。已儲存的結果仍在，我們會稍後重試。"
  ],
  "Reconnecting… Checking whether your Market Brief is ready.": [
    "正在重新连接…检查市场简报是否已生成。",
    "正在重新連線…檢查市場簡報是否已產生。"
  ],
  "We could not confirm whether your brief finished. Refresh to check before trying again.": [
    "暂时无法确认简报是否完成。请先刷新查看，再决定是否重试。",
    "暫時無法確認簡報是否完成。請先重新整理查看，再決定是否重試。"
  ],
  "Search started. Reconnecting to update its progress and your allowance…": [
    "搜索已开始，正在重新连接以更新进度和剩余次数…",
    "搜尋已開始，正在重新連線以更新進度和剩餘次數…"
  ],
  "We could not confirm the search started. Retry safely; this attempt will not be charged twice.": [
    "暂时无法确认搜索是否开始。可以安全重试，本次请求不会重复扣次。",
    "暫時無法確認搜尋是否開始。可以安全重試，本次請求不會重複扣次。"
  ],
  "Preparing your workspace…": [
    "正在准备工作区…",
    "正在準備工作區…"
  ],
  "Opening your private radar…": [
    "正在打开你的私人雷达…",
    "正在開啟你的私人雷達…"
  ],
  "We could not open this workspace.": [
    "暂时无法打开此工作区。",
    "暫時無法開啟此工作區。"
  ],
  "This account may not have an active pilot invitation.": [
    "此账号可能没有有效的试用邀请。",
    "此帳號可能沒有有效的試用邀請。"
  ],
  "Reconnect": [
    "重新连接",
    "重新連線"
  ],
  "Reload page": ["重新加载页面", "重新載入頁面"],
  "Use another account": [
    "使用其他账号",
    "使用其他帳號"
  ],
  "Translating… Original text remains available.": [
    "正在翻译，仍可查看原文。",
    "正在翻譯，仍可查看原文。"
  ],
  "Translation is unavailable. Original text remains available.": [
    "翻译暂不可用，已保留原文。",
    "翻譯暫不可用，已保留原文。"
  ],
  "Retry translation": [
    "重试翻译",
    "重試翻譯"
  ],
  "Show original": [
    "显示原文",
    "顯示原文"
  ],
  "Show translation": [
    "显示译文",
    "顯示譯文"
  ],
  "Translated for reference; check the original when needed.": [
    "译文供参考，需要时可查看原文。",
    "譯文供參考，需要時可查看原文。"
  ],
  "Research content is shown in its original language.": [
    "研究内容目前显示原文。",
    "研究內容目前顯示原文。"
  ],
  "Keep watching {count} company": [
    "继续关注这 {count} 家公司",
    "繼續關注這 {count} 家公司"
  ],
  "Check queued": [
    "检查已排队",
    "檢查已排隊"
  ],
  "Some candidate details could not be confirmed.": [
    "部分候选信息尚未确认。",
    "部分候選資訊尚未確認。"
  ],
  "Contact preparation allowance reached": [
    "联系人准备额度已用完",
    "聯絡人準備額度已用完"
  ],
  "Some people could not be confirmed in their current role or contact channel.": [
    "部分人员的当前任职或联系渠道尚未确认。",
    "部分人員的目前任職或聯絡渠道尚未確認。"
  ],
  "First check pending": [
    "等待首次检查",
    "等待首次檢查"
  ],
  "Last checked · {date}": [
    "上次检查 · {date}",
    "上次檢查 · {date}"
  ],
  "Track company, project and people changes. Contacts are prepared only for companies you Watch.": [
    "关注公司、项目和人员变化。只为你关注的公司准备联系人。",
    "關注公司、專案和人員變化。只為你關注的公司準備聯絡人。"
  ],
  "{count} update to review": [
    "有 {count} 条动态待查看",
    "有 {count} 則動態待查看"
  ],
  "{count} updates to review": [
    "有 {count} 条动态待查看",
    "有 {count} 則動態待查看"
  ],
  "{count} person to approach": [
    "有 {count} 位人员可以联系",
    "有 {count} 位人員可以聯絡"
  ],
  "{count} people to approach": [
    "有 {count} 位人员可以联系",
    "有 {count} 位人員可以聯絡"
  ],
  "No confirmed signals from this check": [
    "本次检查暂无已确认的信号",
    "本次檢查暫無已確認的訊號"
  ],
  "No contact channels confirmed yet": [
    "暂无已确认的联系渠道",
    "暫無已確認的聯絡渠道"
  ],
  "Check details": [
    "检查详情",
    "檢查詳情"
  ],
  "Lead · Needs confirmation": [
    "线索 · 待确认",
    "線索 · 待確認"
  ],
  "Planned activity": [
    "计划中的活动",
    "計劃中的活動"
  ],
  "Planned": [
    "计划日期",
    "計劃日期"
  ],
  "The summary could not be matched to the original wording; details are unconfirmed.": [
    "摘要尚未与原文匹配，细节待确认。",
    "摘要尚未與原文匹配，細節待確認。"
  ],
  "The source does not yet establish all details.": [
    "当前来源尚不能确认所有细节。",
    "目前來源尚不能確認所有細節。"
  ],
  "Original page could not be read; details are unconfirmed.": [
    "未能读取原始页面，细节待确认。",
    "未能讀取原始頁面，細節待確認。"
  ],
  "Workspace not found.": [
    "找不到此工作区。",
    "找不到此工作區。"
  ],
  "This Buyer Radar pilot is currently invitation-only.": [
    "买家雷达目前仅限受邀试用。",
    "買家雷達目前僅限受邀試用。"
  ],
  "Active Buyer Radar access is required.": [
    "需要有效的买家雷达访问权限。",
    "需要有效的買家雷達存取權限。"
  ],
  "Your Watch list is full. Pause a company before adding another.": [
    "关注列表已满，请先暂停一家公司再添加。",
    "關注清單已滿，請先暫停一家公司再新增。"
  ],
  "Your pilot search limit has been reached.": [
    "试用搜索次数已用完。",
    "試用搜尋次數已用完。"
  ],
  "Please retry this search.": [
    "请重试本次搜索。",
    "請重試本次搜尋。"
  ],
  "Confirm the Market Brief before searching.": [
    "请先确认市场简报再搜索。",
    "請先確認市場簡報再搜尋。"
  ],
  "Could not queue the search.": [
    "搜索未能进入队列，请重试。",
    "搜尋未能進入佇列，請重試。"
  ],
  "Could not save feedback.": [
    "反馈保存失败，请重试。",
    "回饋儲存失敗，請重試。"
  ],
  "Could not create your workspace.": [
    "工作区创建失败，请重试。",
    "工作區建立失敗，請重試。"
  ],
  "We read the page but could not build a complete brief. Please try again.": [
    "页面已读取，但未能生成完整简报，请重试。",
    "頁面已讀取，但未能產生完整簡報，請重試。"
  ],
  "We could not understand that seller page. Try another product page.": [
    "未能读取该卖家页面，请尝试另一个产品页面。",
    "未能讀取該賣家頁面，請嘗試另一個產品頁面。"
  ],
  "Confirm your Market Brief before adding companies to Watch.": [
    "请先确认市场简报再关注公司。",
    "請先確認市場簡報再關注公司。"
  ],
  "Add your first company to Watch before editing monitoring focus.": [
    "请先关注一家公司，再修改关注重点。",
    "請先關注一家公司，再修改關注重點。"
  ],
  "Verify your email before opening Buyer Radar.": [
    "请先验证邮箱再打开买家雷达。",
    "請先驗證電郵再開啟買家雷達。"
  ],
  "Email rate limit exceeded": [
    "邮件发送过于频繁，请稍后重试。",
    "電郵傳送過於頻繁，請稍後重試。"
  ],
  "Log out": ["退出登录", "登出"],
  "Logging out…": ["正在退出…", "正在登出…"],
  "Log out of this browser": ["退出当前浏览器的登录", "登出目前瀏覽器"],
  "Could not log out. Please try again.": ["未能退出登录，请重试。", "未能登出，請重試。"],
  "For security purposes, you can only request this after 60 seconds.": [
    "请等待 60 秒后再请求登录链接。",
    "請等待 60 秒後再要求登入連結。"
  ]
};
